import React, { forwardRef } from 'react';

import type { ApparentGenderNullableParameter } from '@vlabs/api/luna-api/model';
import { EVENT_ENUMS } from '@vlabs/api-bindings/src/luna-client/constants';
import { Radio } from '@vlabs/uikit/components/controls/radio';

import type { PopoverWithButtonProps } from '@vlabs/monokit/shared/ui/popovers';
import { PopoverWithButton } from '@vlabs/monokit/shared/ui/popovers';

import { useEventListFilters } from '../../useEventListFilters';
import st from '../popovers.module.sass';

interface ApparentGenderOption {
  value: ApparentGenderNullableParameter[number];
  label: string;
}

const apparentGenderOptions = EVENT_ENUMS.BODY_BASIC_ATTRIBUTES.APPARENT_GENDER.raw as ApparentGenderOption[];

function ApparentGenderFilterPopover(
  props: PopoverWithButtonProps,
  ref: React.ForwardedRef<HTMLDivElement>,
) {
  const { filters, updateFilters } = useEventListFilters();

  const selectedApparentGender = filters.apparent_gender ?? [];

  return (
    <PopoverWithButton
      {...props}
      isButtonDisabled={selectedApparentGender.length === 0}
      onClickReset={() => updateFilters({ apparent_gender: undefined })}
      ref={ref}
    >
      <div className={st.RadioWrapper}>
        {apparentGenderOptions.map((option) => (
          <Radio
            checked={selectedApparentGender[0] === option.value}
            key={option.label}
            label={option.label}
            onChange={() => updateFilters({ apparent_gender: [option.value] })}
          />
        ))}
      </div>
    </PopoverWithButton>
  );
}

const ApparentGenderFilterPopoverWithRef = forwardRef(ApparentGenderFilterPopover);
export { ApparentGenderFilterPopoverWithRef as ApparentGenderFilterPopover };
